import { useMemo, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useImmer } from 'use-immer'
import { Button, FormControl, FormLabel, Input, VStack } from '@chakra-ui/react'

export const FabricationVendorFormType = {
  Add: 'add',
  Edit: 'edit'
}

export const FabricationVendorForm = ({ type, onSubmit, isSubmitting, initialForm = null }) => {
  const [form, setForm] = useImmer({
    name: '',
    contact: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    state: '',
    zip: ''
  })

  const buttonText = useMemo(() => {
    switch (type) {
      case FabricationVendorFormType.Add:
        return 'Add Vendor'
      case FabricationVendorFormType.Edit:
        return 'Save Vendor'
    }
  }, [type])

  useEffect(() => {
    setForm(draft => {
      Object.keys(initialForm || {}).forEach(k => { draft[k] = initialForm[k] ?? '' })
    })
  }, [initialForm])

  const handleChange = (e) => {
    setForm(draft => {
      draft[e.target.name] = e.target.value
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit(form)
  }

  return (
    <form onSubmit={handleSubmit}>
      <VStack gap={2} maxW="500px">
        <FormControl isRequired>
          <FormLabel>Name</FormLabel>
          <Input name="name" value={form.name} onChange={handleChange} />
        </FormControl>
        <FormControl>
          <FormLabel>Contact Name</FormLabel>
          <Input name="contact" value={form.contact} onChange={handleChange} />
        </FormControl>
        <FormControl isRequired>
          <FormLabel>Email</FormLabel>
          <Input name="email" value={form.email} onChange={handleChange} />
        </FormControl>
        <FormControl isRequired>
          <FormLabel>Phone</FormLabel>
          <Input name="phone" value={form.phone} onChange={handleChange} />
        </FormControl>
        <FormControl isRequired>
          <FormLabel>Address</FormLabel>
          <Input name="address" value={form.address} onChange={handleChange} />
        </FormControl>
        <FormControl isRequired>
          <FormLabel>City</FormLabel>
          <Input name="city" value={form.city} onChange={handleChange} />
        </FormControl>
        <FormControl isRequired>
          <FormLabel>State</FormLabel>
          <Input name="state" value={form.state} onChange={handleChange} />
        </FormControl>
        <FormControl isRequired>
          <FormLabel>Zip</FormLabel>
          <Input name="zip" value={form.zip} onChange={handleChange} />
        </FormControl>
      </VStack>
      <Button type="submit" mt={8} colorScheme="blue" isLoading={isSubmitting}>{buttonText}</Button>
    </form>
  )
}

FabricationVendorForm.propTypes = {
  type: PropTypes.oneOf(Object.values(FabricationVendorFormType)).isRequired,
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  initialForm: PropTypes.object
}
